import firebase from "firebase";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
//GET Below Settings from Firebase > Project Overview > Settings > General > Your apps > Firebase SDK snippet > Config
const firebaseConfig = {
    apiKey: "AIzaSyAgLC63X4Ra13taT1xnwDyC4Ftwo51Mq4g",
    authDomain: "whatsapp-fe34b.firebaseapp.com",
    databaseURL: "https://whatsapp-fe34b-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "whatsapp-fe34b",
    storageBucket: "whatsapp-fe34b.appspot.com",
    messagingSenderId: "71616770727",
    appId: "1:71616770727:web:82752e33f9bc0b14e2a182",
    measurementId: "G-JC75B25F1Y"
  };

  // apiKey: "AIzaSyAgLC63X4Ra13taT1xnwDyC4Ftwo51Mq4g",
  // authDomain: "whatsapp-fe34b.firebaseapp.com",
  // projectId: "whatsapp-fe34b",
  // storageBucket: "whatsapp-fe34b.appspot.com",
  // messagingSenderId: "71616770727",
  // appId: "1:71616770727:web:82752e33f9bc0b14e2a182",
  // measurementId: "G-JC75B25F1Y"

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore(); 
  const auth = firebaseApp.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth,provider};
  export default db;
